__turbopack_context__.v({
  "fadeIn": "QSLloa_fadeIn",
  "menuButton": "QSLloa_menuButton",
  "overlay": "QSLloa_overlay",
  "polBtns": "QSLloa_polBtns",
  "polCloseBtn": "QSLloa_polCloseBtn",
  "polContent": "QSLloa_polContent",
  "polPrimary": "QSLloa_polPrimary",
  "polProductRow": "QSLloa_polProductRow",
  "polSecondaryRow": "QSLloa_polSecondaryRow",
  "polSubtitle": "QSLloa_polSubtitle",
  "polTitle": "QSLloa_polTitle",
  "productCard": "QSLloa_productCard",
  "secSubtitle": "QSLloa_secSubtitle",
  "secTitle": "QSLloa_secTitle",
});
